// ScrollToTopButton.jsx
import React, { useState, useEffect } from 'react';
import { FaAngleDoubleUp } from 'react-icons/fa';

/* Scroll Top Buttom */

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 bg-[#010138] p-3 rounded-full shadow-lg hover:scale-110 transition-transform"
        >
          <FaAngleDoubleUp size={16} color="white" />
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
